// Prototype ZIP check. Coverage comes from Theme settings → Delivery → "ZIP prefixes"
// (the hero section may override it)
// (format: "Metro:770,772;Other:786"). Replace with supplier-confirmed ZIP coverage before launch.
(function () {
  document.querySelectorAll('[data-ttr-zip]').forEach(function (form) {
    var input = form.querySelector('input');
    var out = form.querySelector('.zip-result');
    var metros = {};
    (form.getAttribute('data-ttr-zip') || '').split(';').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) metros[parts[0].trim()] = parts[1].split(',').map(function (p) { return p.trim(); });
    });
    var served = Object.keys(metros).join(', ');
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 5); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = input.value.trim();
      out.className = 'zip-result show';
      if (!/^\d{5}$/.test(zip)) {
        out.classList.add('err');
        out.textContent = 'Enter a 5-digit ZIP code.';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      var prefix = zip.slice(0, 3), found = null;
      Object.keys(metros).forEach(function (m) { if (metros[m].indexOf(prefix) > -1) found = m; });
      if (found) {
        out.classList.add('ok');
        out.textContent = zip + ' looks to be in our ' + found + ' delivery area. ' +
          (form.getAttribute('data-ok-msg') || 'Delivered prices and dates will show on each tree page.');
      } else {
        out.classList.add('no');
        out.textContent = "We don't deliver to " + zip + ' yet. We currently serve the ' + served + ' metros.';
      }
      // Product pages listen for this to unlock Add to cart and show the delivery window.
      form.dispatchEvent(new CustomEvent('ttr:zip', { bubbles: true, detail: { zip: zip, metro: found } }));
    });
  });
})();
